import React from 'react'
import Footer from 'site/Footer'
import FeatureIntroduction from 'site/Landing/FeatureIntroduction'
import styled from 'styled-components'
import { featureGroups1, featureGroups2, featureGroups3 } from './staticData'
import { Card, CardText, FontIcon } from 'react-md'
import {
	ActionAnchorButton,
	PrimaryActionAnchorButton,
	ContentContainer,
	FirstStripe,
	PageContainer,
	PageTitleSection,
	StripeBase,
} from 'site/styledComponents/sharedComponents'
import { maxScreenWidth } from 'ui/StyledComponents/MediaBreakpoints'
import PromoStamp from '../assets/svgs/promo_stamp.svg'
import FeatureCard from 'site/Landing/FeatureIntroduction/FeatureCard'
import { StandardCard } from 'ui/StyledComponents/Cards'
import Jarvinen from 'site/assets/images/jarvinen.jpeg'

const ActionAnchorButtonsContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	flex-grow: 1;
	margin: 40px auto;
	margin-top: 16px;
	max-width: 600px;
	@media only screen and (max-width: 768px) {
		flex-wrap: wrap;
	}
`
const PromoCard = styled(Card)`
	background: white;
	padding: 48px;
	border-radius: 8px;
	display: flex;
	flex-direction: row;
	margin-top: 48px;
	margin-bottom: 48px;
	h2 {
		color: #4a4a4a;
		font-size: 40px;
		margin-top: 0;
		margin-bottom: 20px;
	}
	p {
		font-weight: 200;
		font-size: 20px;
		color: #4a4a4a;
		margin-bottom: 24px;
	}
	a {
		width: fit-content;
		margin: 0;
	}

	@media screen and (max-width: ${maxScreenWidth.phone}px) {
		padding: 32px 24px;
		flex-wrap: wrap;
		justify-content: center;
		h2 {
			font-size: 32px;
		}
		p {
			padding-top: 16px;
		}
	}
`
const ProductStripeBase = styled(StripeBase)``
const ProductStripe2 = styled(ProductStripeBase)`
	top: 130vh;
	z-index: -3;
	clip-path: polygon(0 128px, 100% 0, 100% 768px, 0 1024px);
`
const ProductStripe3 = styled(ProductStripeBase)`
	top: calc(130vh + 800px);
	z-index: -2;
	clip-path: polygon(0 0, 100% 128px, 100% 1024px, 0 768px);
`
const ProductStripe4 = styled(ProductStripeBase)`
	top: calc(130vh + 1600px);
	z-index: -1;
	clip-path: polygon(0 128px, 100% 0, 100% 768px, 0 1024px);
`

export default function Infoscreens() {
	return (
		<PageContainer>
			<FirstStripe style={{ zIndex: -5 }} />
			<ContentContainer>
				<PageTitleSection>
					<h1>Isännöitsijälle</h1>
				</PageTitleSection>
				<FeatureIntroduction featureGroups={featureGroups1} />
				<PromoCard>
					<img
						src={PromoStamp}
						alt="illustraatio"
						style={{ marginRight: 32, maxHeight: 96 }}
					/>
					<p style={{ margin: 0 }}>
						Viilun keskittämisedun kautta saatte säästöä, kun keskitätte
						toimintaanne Viilun päälle. Tämä ei kuitenkaan tarkoita, ettetkö
						voisi ottaa vain jotain tarvitsemaasi siivua käyttöön. Viilu
						integroituu monien muiden palveluiden kanssa näppärästi.
					</p>
				</PromoCard>
				<FeatureIntroduction featureGroups={featureGroups2} flip />
				<PageTitleSection>
					<h2>Mitä mieltä asiakkaamme ovat?</h2>
				</PageTitleSection>

				<div
					style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
				>
					<FeatureCard
						title={featureGroups3[0].title}
						features={featureGroups3[0].features}
						style={{ marginRight: 8 }}
					/>
					<div
						style={{
							marginLeft: 8,
							display: 'flex',
							flexDirection: 'column',
							maxWidth: 400,
							justifyContent: 'flex-start',
						}}
					>
						<a
							href="https://youtu.be/dviJawUg5LU"
							target="_blank"
							rel="noreferrer"
						>
							<StandardCard
								style={{
									marginBottom: 16,
									maxHeight: 250,
									position: 'relative',
								}}
							>
								<img
									src={Jarvinen}
									style={{
										margin: 0,
										padding: 0,
										width: '100%',
									}}
									alt="Illustraatio"
								/>
								<div
									style={{
										position: 'absolute',
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
										background: 'rgba(0,0,0,0.2)',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										flexDirection: 'column',
										borderWidth: 3,
										borderStyle: 'solid',
										borderColor: 'white',
										borderRadius: 8,
									}}
								>
									<FontIcon
										style={{
											fontSize: 56,
											color: 'white',
										}}
									>
										play_circle
									</FontIcon>
								</div>
								<div
									style={{
										background: 'white',
										color: 'rgba(0,0,0,0.6)',
										borderTopLeftRadius: 4,
										borderBottomRightRadius: 4,
										padding: 4,
										fontSize: 10,
										position: 'absolute',
										top: 0,
										left: 0,
									}}
								>
									KATSO VIDEO
								</div>
							</StandardCard>
						</a>
						<StandardCard>
							<CardText>
								“Viilusta on kyllä kovasti tykätty ja käyttäjiltä on tullut
								kommentteja, että sitä on helppo käyttää. Kyselytyökalujen
								avulla voidaan kuulla esimerkiksi osakkaiden ja asukkaiden
								mielipiteitä helposti. Kyseessä on sellainen moderni
								järjestelmä, jota on näppärä käyttää ihan mobiilisti
								kännykällä.“
							</CardText>
							<div style={{ padding: 16, paddingTop: 0 }}>
								<strong>Jonna Rantala</strong>
								<p>Isännöitsijä, toimitusjohtaja</p>
								<p>Isännöintipalvelu Järvinen</p>
							</div>
						</StandardCard>
					</div>
				</div>

				<ActionAnchorButtonsContainer>
					<PrimaryActionAnchorButton href="/demo">
						Varaa demo
					</PrimaryActionAnchorButton>
					<ActionAnchorButton href="/pricing">
						Tutustu hinnastoon
					</ActionAnchorButton>
				</ActionAnchorButtonsContainer>
			</ContentContainer>
			<ProductStripe2 />
			<ProductStripe3 />
			<ProductStripe4 />
			<Footer />
		</PageContainer>
	)
}
